import { clearCSLocalStorage, clearTimer, isKasbon } from 'helpers/Utility';
import {
  setCreditScoreResult,
  setHomePath,
  setNextDate,
  setResponseCodeReject,
  setSelectedOffering,
  setTimer,
  startTimer,
  stopTimer
} from 'store/actions';

const handleDeclined = (dispatch, plafond2, tenure2) => {
  dispatch(setSelectedOffering({ plafond: plafond2, tenure: tenure2 }));
  dispatch(setCreditScoreResult('user-declined'));
  clearTimer(dispatch);
};

const handleAlternativeKasbon = (dispatch, alternative) => {
  dispatch(
    setSelectedOffering({
      plafond: alternative[0]?.plafond,
      tenure: alternative[0]?.tenor
    })
  );
  dispatch(setCreditScoreResult('approved'));
  clearTimer(dispatch);
};

const handleAlternativeNonKasbon = (
  dispatch,
  plafond2,
  tenure2,
  installment2,
  serviceFeePercentage
) => {
  dispatch(
    setSelectedOffering({
      plafond: plafond2,
      tenure: tenure2,
      installment: installment2,
      serviceFeePercentage: serviceFeePercentage
    })
  );
  dispatch(setCreditScoreResult('user-declined-alternatif'));
  clearTimer(dispatch);
};

const handleMultipleOfferings = (
  dispatch,
  isKasbonScheme,
  alternative,
  plafond1,
  tenure1,
  installment1,
  plafond2,
  tenure2,
  installment2,
  serviceFeePercentage
) => {
  if (isKasbonScheme) {
    handleAlternativeKasbon(dispatch, alternative);
  } else {
    dispatch(
      setSelectedOffering({
        plafond: plafond2,
        tenure: tenure2,
        installment: installment2,
        serviceFeePercentage: serviceFeePercentage
      })
    );
    dispatch(
      setSelectedOffering({
        plafond: plafond1,
        tenure: tenure1,
        installment: installment1,
        serviceFeePercentage: serviceFeePercentage
      })
    );
    dispatch(setCreditScoreResult('offering'));
    clearTimer(dispatch);
  }
};

const handleDefaultApproval = (
  dispatch,
  {
    plafond1,
    tenure1,
    plafond2,
    tenure2,
    serviceFeePercentage,
    serviceFeeAmount,
    plafondWithService
  }
) => {
  const selected =
    plafond1 > 0
      ? {
          plafond: plafond1,
          tenure: tenure1,
          serviceFeePercentage: serviceFeePercentage,
          serviceFeeAmount: serviceFeeAmount,
          plafondWithService: plafondWithService
        }
      : {
          plafond: plafond2,
          tenure: tenure2,
          serviceFeePercentage: serviceFeePercentage,
          serviceFeeAmount: serviceFeeAmount,
          plafondWithService: plafondWithService
        };

  dispatch(setSelectedOffering(selected));
  dispatch(setCreditScoreResult('approved'));
  clearTimer(dispatch);
};

/**
 * to handle credit score sub
 * @param {*} dispatch
 * @param {*} data
 * @param {*} params
 */
const handleCreditScoreSub = (dispatch, data, params) => {
  localStorage.setItem('setCS', 1);

  dispatch(
    setTimer({
      minutes: data.timeLeftForScoreCompletion,
      seconds: 0
    })
  );
  dispatch(startTimer());

  if (params && !params.isCounting) {
    dispatch(setCreditScoreResult(''));
    dispatch(startTimer());
  }
};

/**
 * to handle credit score approved
 * @param {*} dispatch
 * @param {*} data
 * @param {*} params
 * @returns
 */
const handleCreditScoreApr = (dispatch, data, params) => {
  clearCSLocalStorage();

  const details = data.approvalDetails || {};
  const {
    isKTPVerified,
    alternative,
    plafond1,
    plafond2,
    tenor1: tenure1,
    tenor2: tenure2,
    approvalAmount,
    serviceFeePercentage,
    serviceFeeAmount,
    plafondWithService
  } = details;

  const installment1 = details.oneMonthPayDetails?.oneMonthPayForPlafond1;
  const installment2 = details.monthlyPayDetails?.find(
    i => i.loanTenor === Number(tenure2)
  )?.monthlyPayment;

  const isKasbonScheme = isKasbon(data.schemeCode);

  // If approval amount is present, proceed to disbursement
  if (approvalAmount > 0) {
    dispatch(setHomePath('/continue-disburse'));
  }

  // Case 1: Declined
  if (plafond1 === 0 && isKTPVerified === 'Y' && params?.checking) {
    return handleDeclined(dispatch, plafond2, tenure2);
  }

  // Case 2: Alternative
  if (alternative && isKTPVerified === 'Y') {
    return isKasbonScheme
      ? handleAlternativeKasbon(dispatch, alternative)
      : handleAlternativeNonKasbon(
          dispatch,
          plafond2,
          tenure2,
          installment2,
          serviceFeePercentage
        );
  }

  // Case 3: Multiple offerings
  if ((plafond1 > 0 && plafond2 > 0 && plafond2 > plafond1) || alternative) {
    return handleMultipleOfferings(
      dispatch,
      isKasbonScheme,
      alternative,
      plafond1,
      tenure1,
      installment1,
      plafond2,
      tenure2,
      installment2,
      serviceFeePercentage
    );
  }

  // Default
  handleDefaultApproval(dispatch, {
    plafond1,
    tenure1,
    plafond2,
    tenure2,
    serviceFeePercentage,
    serviceFeeAmount,
    plafondWithService
  });
};

/**
 * to handle credit score status
 * @param {*} dispatch
 * @param {*} appStatus
 * @param {*} data
 * @param {*} params
 */
export const handleCreditScoreStatus = (dispatch, appStatus, data, params) => {
  dispatch(setHomePath('/credit-scoring'));

  if (appStatus === 'CR_SCORE_SUB') {
    handleCreditScoreSub(dispatch, data, params);
  } else if (appStatus === 'CR_SCORE_APR') {
    handleCreditScoreApr(dispatch, data, params);
  } else if (appStatus === 'CR_SCORE_REJ') {
    dispatch(setNextDate(data.rejectionDetails.nextEligibilityDate));
    dispatch(setResponseCodeReject(data.rejectionDetails.responseCode));
    dispatch(setCreditScoreResult('rejected'));
    localStorage.removeItem('documentDetails');
    dispatch(setTimer({ minutes: '', seconds: '' }));
    dispatch(stopTimer());
  }
};
